import { useQuery } from '@tanstack/react-query';
import { getRuleTestResults } from 'Services';
import { RQ_GET_RULE_TEST_RESULTS } from 'Utils';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUser } from 'Selectors';

type Props = {
    ruleId: string | null;
    shouldPoll: boolean;
    ruleTestId: string | null;
    mode?: string;
    merchantId: string;
    tenantGroupId: string;
    ruleSetId: string;
};

const useGetRuleTestResults = ({
    ruleId,
    shouldPoll = false,
    mode,
    ruleTestId,
    merchantId,
    tenantGroupId,
    ruleSetId
}: Props) => {
    const { addAlert } = useAlertBanner();
    const { t } = useTranslation();
    const { userId, tenantKey } = useSelector(getUser);

    return useQuery(
        [RQ_GET_RULE_TEST_RESULTS, ruleId, tenantKey, merchantId, tenantGroupId, ruleSetId],
        () => getRuleTestResults(ruleId, merchantId, tenantGroupId, ruleSetId),
        {
            refetchOnWindowFocus: false,
            enabled:
                (mode !== 'edit' && ruleTestId && !!ruleId) ||
                (mode === 'edit' && !!ruleId) ||
                (mode === 'read' && !!ruleId) ||
                false,
            refetchInterval: shouldPoll ? 5000 : undefined,
            refetchIntervalInBackground: true,
            select: (results) => {
                return {
                    ...results
                };
            },
            onSuccess: (response) => {
                if (userId === response.createdBy && ruleTestId) {
                    if (response.status === 'FINISHED') {
                        addAlert({
                            id: 'rule-test-success',
                            content: t('addRuleTestSuccess', { ruleId }),
                            status: 'success'
                        });
                    } else if (response.status === 'Failed') {
                        addAlert({
                            id: 'rule-test-error',
                            content: t('addRuleTestError', { ruleId }),
                            status: 'danger'
                        });
                    }
                }
            }
        }
    );
};

export default useGetRuleTestResults;
